import { Product } from './product.model';
import { Operation } from './operation.model';

import moment, { Moment } from 'moment';

import {APP_DI_CONFIG} from '../../../app/app-config.module';

/**
 * Contiene el formato por defecto de la fecha.
 */
const DATE_FORMAT = APP_DI_CONFIG.dateMask;

/**
 * Clase para manejar los datos de una fichada.
 *
 * @export
 * @class ClockIn
 */
export class ClockIn{


    /**
     * Hora de inicio.
     *
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _start: string = '';


    /**
     * Hora de finalización
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _end: string = '';


    /**
     * Tiempo total.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _time: string = '';


    /**
     * Cantidad.
     *
     * @private
     * @type {number}
     * @memberof ClockIn
     */
    private _qty: number = 0;


    /**
     * Cantidad fabricada.
     *
     * @private
     * @type {number}
     * @memberof ClockIn
     */
    private _qtyFab: number = 0;

    /**
     * Código del operador.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _operator: string = '';


    /**
     * Nombre del operador.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _name: string = '';

    /**
     * Código de la orden de fabricación.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _manufacturingOrder: string = '';

    /**
     * Registro de la orden de fabricación.
     *
     * @private
     * @type {strin}
     * @memberof ClockIn
     */
    private _regMO: string = '';

    /**
     * Operación de la fichada.
     *
     * @private
     * @type {Operation}
     * @memberof ClockIn
     */
    private _operation: Operation = new Operation();


    /**
     * Máquina de la fichada.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _machine: string = '';

    /**
     * Productos de la fichada.
     *
     * @private
     * @type {Array<Product>}
     * @memberof ClockIn
     */
    private _products: Array<Product> = [];


    /**
     * Perdido.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _order: string = '';


    /**
     * Cliente.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _client: string = '';


    /**
     * Observaciones.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _observations: string = '';


    /**
     * Contiene los productos disponibles según la OF.
     *
     * @private
     * @type {Array<Product>}
     * @memberof ClockIn
     */
    private _relatedProducts: Array<Product> = [];


    /**
     * Contiene las operaciones disponibles según producto.
     *
     * @private
     * @type {Array<Operation>}
     * @memberof ClockIn
     */
    private _relatedOperations: Array<Operation> = [];


    /**
     * Contiene el id registro de la fichada.
     *
     * @private
     * @type {string}
     * @memberof ClockIn
     */
    private _register: string = '';

    /**
     * Contiene las coordenadas de latitud de inicio de fichada
     */
    private _CoordStartLat: number = null;

    /**
     * Contiene las coordenadas de longitud de inicio de fichada
     */
    private _CoordStartLong: number = null;

    /**
     * Contiene las coordenadas de latitud de fin de fichada
     */
    private _CoordEndLat: number = null;

    /**
     * Contiene las coordenadas de longitud de fin de fichada
     */
    private _CoordEndLong: number = null;

    /**
     * Crea una instancia de ClockIn.
     * @memberof ClockIn
     */
    constructor(){
    }


    /**
     * Inicio getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get start(): string{
        return this._start;
    }


    /**
     * Inicio setter.
     *
     * @memberof ClockIn
     */
    set start(start: string){
        this._start = start;
    }

    /**
     * Inicio getter en HH:mm.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get startHHmm(): string{
        return moment(this._start,DATE_FORMAT).format('HH:mm');
    }

    /**
     * Inicio setter en HH:mm.
     *
     * @memberof ClockIn
     */
    set startHHmm(time: string){
        let times =  time.split(':');
        this._start = moment(this._start, DATE_FORMAT).set({
            'hour' : parseInt(times[0]?times[0]:'00'),
            'minute'  : parseInt(times[1]?times[1]:'00'),
            'second' : parseInt(times[2]?times[2]:'00')
         }).format(DATE_FORMAT);
    }

     /**
     * Fin getter en HH:mm.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get endHHmm(): string{
        return moment(this._end,DATE_FORMAT).format('HH:mm');
    }

    /**
     * Fin setter en HH:mm.
     *
     * @memberof ClockIn
     */
    set endHHmm(time: string){
        let times =  time.split(':');
        this._end = moment(this._start, DATE_FORMAT).set({
            'hour' : parseInt(times[0]?times[0]:'00'),
            'minute'  : parseInt(times[1]?times[1]:'00'),
            'second' : parseInt(times[2]?times[2]:'00')
         }).format(DATE_FORMAT);
    }

    /**
     * Fin getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get end(): string{
        return this._end;
    }

    /**
     * Fin setter.
     *
     * @memberof ClockIn
     */
    set end(end: string){
        this._end = end;
    }

    /**
     * Tiempo getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get time(): string{
        return this._time;
    }

    /**
     * Tiempo setter.
     *
     * @memberof ClockIn
     */
    set time(time: string){
        this._time = parseFloat(time).toString();
    }

    /**
     * Qty getter.
     *
     * @type {number}
     * @memberof ClockIn
     */
    get qty(): number{
        return this._qty;
    }

    /**
     * Qty setter.
     *
     * @memberof ClockIn
     */
    set qty(qty: number){
        this._qty = qty;
    }

    /**
     * QtyFab getter.
     *
     * @type {number}
     * @memberof ClockIn
     */
    get qtyFab(): number{
        return this._qtyFab;
    }

    /**
     * QtyFab setter.
     *
     * @memberof ClockIn
     */
    set qtyFab(qty: number){
        this._qtyFab = qty;
    }

    /**
     * Operario getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get operator(): string{
        return this._operator;
    }


    /**
     * Operario setter.
     *
     * @memberof ClockIn
     */
    set operator(operator: string){
        this._operator = operator;
    }

    /**
     * Nombre operario getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get name(): string{
        return this._name;
    }


    /**
     * Nombre operario setter.
     *
     * @memberof ClockIn
     */
    set name(name: string){
        this._name = name;
    }

    /**
     * Orden de fabricación getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get manufacturingOrder(): string{
        return this._manufacturingOrder;
    }

    /**
     * Orden de fabricación setter.
     *
     * @memberof ClockIn
     */
    set manufacturingOrder(manufacturingOrder: string){
        if(manufacturingOrder != this.manufacturingOrder){
            this.relatedProducts = [];
            this.products = [];
        }
        this._manufacturingOrder = manufacturingOrder;
    }

    /**
     * Registro de orden de fabricación getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get regMO(): string{
        return this._regMO;
    }

    /**
     * Registro de orden de fabricación setter.
     *
     * @memberof ClockIn
     */
    set regMO(register: string){
        this._regMO = register;
    }

    /**
     * Operación getter
     *
     * @type {Operation}
     * @memberof ClockIn
     */
    get operation(): Operation{
        return this._operation;
    }

    /**
     * Operación setter.
     *
     * @memberof ClockIn
     */
    set operation(operation: Operation){
        this._operation = operation;
    }

    /**
     * Máquina getter
     *
     * @type {string}
     * @memberof ClockIn
     */
    get machine(): string{
        return this._machine;
    }

    /**
     * Máquina setter.
     *
     * @memberof ClockIn
     */
    set machine(machine: string){
        this._machine = machine;
    }

    /**
     * Productos getter.
     *
     * @type {Array<Product>}
     * @memberof ClockIn
     */
    get products(): Array<Product>{
        return this._products;
    }


    /**
     * Productos setter.
     *
     * @memberof ClockIn
     */
    set products(products: Array<Product>){
        if(products){
            if(
                !Array.isArray(this._products) ||
                !this._products.length ||
                !products.length ||
                this._products[0].code != products[0].code
            ){
                this._relatedOperations  = [];
                this.operation = new Operation();
            }
        }

        this._products = products;
    }


    /**
     * Devuelve el primer producto.
     *
     * Si el array está vacío devuelve un producto nuevo.
     *
     * @readonly
     * @type {Product}
     * @memberof ClockIn
     */
    get product(): Product{
        if(!this._products.length) return null;
        return this._products[0];
    }



    /**
     * Establece el array de producto.
     *
     * Reinicia el array de operaciones relacionadas y la operación seleccionada.
     *
     * @memberof ClockIn
     */
    set product(product: Product){
        if(product.code != this.product.code) {
            this.relatedOperations  = [];
            this.operation = new Operation();
        }

        this._products = [product];
    }

    /**
     * Pedido getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get order(): string{
        return this._order;
    }

    /**
     * Pedido setter.
     *
     * @memberof ClockIn
     */
    set order(order: string){
        this._order = order;
    }

    /**
     * Cliente getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get client(): string{
        return this._client;
    }

    /**
     * Cliente setter.
     *
     * @memberof ClockIn
     */
    set client(client: string){
        this._client = client;
    }

    /**
     * Observaciones getter.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get observations(): string{
        return this._observations;
    }

    /**
     * Devuelve las observaciones de la fichada.
     *
     * @memberof ClockIn
     */
    set observations(observations: string){
        this._observations = observations;
    }

    /**
     * Devuelve los productos relacionados con la OF.
     *
     * @memberof ClockIn
     */
    get relatedProducts(){
        return this._relatedProducts;
    }

    /**
     * Establece los productos relacionados con la OF.
     *
     * @memberof ClockIn
     */
    set relatedProducts(products: Array<Product>){
        this._relatedProducts = products;
    }


    /**
     * Devuelve las operaciones con las operaciones relacionadas con los productos.
     *
     * @readonly
     * @type {Array<Operation>}
     * @memberof ClockIn
     */
    get relatedOperations(): Array<Operation>{
        return this._relatedOperations;
    }

    /**
     * Assigna las operaciones relacionadas con el producto.
     *
     * @memberof ClockIn
     */
    set relatedOperations(operations: Array<Operation>){
        this._relatedOperations = operations;
    }

    /**
     * Devuelve el id de registro de fichada.
     *
     * @type {string}
     * @memberof ClockIn
     */
    get register(): string{
        return this._register;
    }

    /**
     * Establece el id de registro de la fichada.
     *
     * @memberof ClockIn
     */
    set register(register: string){
        this._register = register;
    }

    /**
     * Asigna las coordenadas de inicio de fichada
     */
    setCoordStart(latitud: number, longitud: number): void {
        this._CoordStartLat  = latitud;
        this._CoordStartLong = longitud;
    }

    /**
     * devuelve las coordenadas de inicio de fichada en un string
     */
    get CoordStart(): string {
        if(this._CoordStartLat != 0 && this._CoordStartLong != 0) {
            return this._CoordStartLat.toString() + ',' + this._CoordStartLong.toString();
        }
        else return '';
    }

    /**
     * Asigna las coordenadas de fin de fichada
     */

    setCoordEnd(latitud: number, longitud: number): void {
        this._CoordEndLat  = latitud;
        this._CoordEndLong = longitud;
    }

    /**
     * devuelve las coordenadas de inicio de fichada en un string
     */
    get CoordEnd(): string {
        if(this._CoordEndLat != 0 && this._CoordEndLong != 0){
            return this._CoordEndLat.toString() + ',' + this._CoordEndLong.toString();
        }
        else return '';
    }


    /**
     * Assigna los parámetros a partir de una respuesta HTTP.
     *
     * @param {*} params
     * @memberof ClockIn
     */
    setFromResponse(params: any, defaultValues: any = {}): void{
        if(params===null) return;

        let parsedValues = JSON.parse(JSON.stringify(defaultValues));
        /* Ejemplo respuesta:
            cod_comanda: "4500295545" //Id de la comanda
            cod_of: "180041" //Código de la OF
            desc_operacion: "MEC TORN 1" //Descripción de la operación
            desc_producto_of: "TUBO VENTURI." //Descripción del producto
            id_reg_ofsproductos: "xxxxx"
            id_reg_ofsprod_operacion: 2493 //Código de la operación a iniciar
            id_rt_operario: 60 //Registro de fichadas de usuario
            nombre: "GIRBAU" //Nombre de cliente
            observaciones: "" //Observaciones
        */
        this._operation = new Operation();
        let product = new Product();
        this.products = [];

        this.name = this.formatParam(params.nombre_operario);
        this.order = this.formatParam(params.cod_comanda);
        this.manufacturingOrder = this.formatParam(this.formatParam(params.cod_of));
        product.name = this.formatParam(params.desc_producto_of);
        product.code = this.formatParam(params.id_reg_ofsproductos);
        product.of = this.manufacturingOrder;
        this.products.push(product);
        this._operation.name = this.formatParam(params.desc_operacion);
        this._operation.product = product.code;
        this._operation.code = this.formatParam(params.id_reg_ofsprod_operacion);
        this.start = this.formatParam(params.hora_ini);
        this.client = this.formatParam(params.nombre);
        this.observations = this.formatParam(params.observaciones);
        this.register = this.formatParam(params.id_reg_ofsoperarios);
    }

    /**
     * Sobrescribe un ClockIn con parámetros JSON
     *
     * @param {*} params Parámetros en formato JSON
     * @memberof ClockIn
     */
    overwriteFromResponse(params: any): void{
       this.order = this.formatParam(params.cod_comanda);
       this.manufacturingOrder = this.formatParam(this.formatParam(params.cod_of));
       if(!this.products.length){
        this._products = [new Product()];
       }
       else this.products[0].name = this.formatParam(params.desc_producto_of);
       this._operation.name = this.formatParam(params.desc_operacion);
       this._operation.code = this.formatParam(params.id_reg_ofsprod_operacion);
       this.start = this.formatParam(params.hora_ini);
       this.client = this.formatParam(params.nombre);
       this.observations = this.formatParam(params.observaciones);
       this.register = this.formatParam(params.id_reg_ofsoperarios);

    }

    setFromResponseHistory(params: any): void{
        /* Ejemplo respuesta:
            cantidad_fab: 0
            cliente: "GIRBAU"
            costehora: "0.00"
            entradasalida: 0
            hora_fin: "2018-01-17 11:00:00"
            hora_ini: "2018-01-17 08:00:00"
            horas: "2.5000"
            id_mst_maquinas: 1
            id_mst_operacion: 14
            id_mst_operarios: 1
            id_reg_ofs: 4891
            id_reg_ofsoperarios: 20027
            id_reg_ofsprod_operacion: 1702
            id_reg_ofsproductos: 11895
            latitudentrada: 0
            latitudsalida: 0
            longitudentrada: 0
            longitudsalida: 0
            manual: 0
            maquina: "TORN DOOSAN"
            observaciones: "eje cierre t-1"
            of: "180045"
            operacion: "MEC TORN 1"
            producto: "A - 276485 - EJE CIERRE."
        */
        this._operation = new Operation();
        let product = new Product();
        this.products = [];

        //Operador
        this.operator = this.formatParam(params.id_mst_operarios);
        //OF
        this.regMO = this.formatParam(params.id_reg_ofs);
        this.manufacturingOrder = this.formatParam(params.of);
        //Producto
        product.name = this.formatParam(params.producto);
        product.code = this.formatParam(params.id_reg_ofsproductos);
        product.of = this.manufacturingOrder;
        this.products.push(product);
        //Cantidades
        this.qtyFab = parseInt(this.formatParam(params.cantidad_fab));
        this.qty = parseInt(this.formatParam(params.cantidad));
        //Maquina
        this.machine = this.formatParam(params.maquina);

        //Operacion
        this._operation.code = this.formatParam(params.id_reg_ofsprod_operacion);
        this._operation.name = this.formatParam(params.operacion);
        this._operation.product = product.code;

        //Inicio
        this.start = this.formatParam(params.hora_ini);
        //Fin
        this.end = this.formatParam(params.hora_fin);
        //Total
        this.time = this.formatParam(params.horas);
        //Cliente
        this.client = this.formatParam(params.cliente);
        //Observaciones
        this.observations = this.formatParam(params.observaciones);
        //Id del registro
        this.register = this.formatParam(params.id_reg_ofsoperarios);


        //N/A??
        this.order = this.formatParam(params.cod_comanda); //Delete?


        //Coordenades fichada
        this.setCoordStart(Number(this.formatParam(params.latitudentrada)), Number(this.formatParam(params.longitudentrada)));
        this.setCoordEnd(Number(this.formatParam(params.latitudsalida)), Number(this.formatParam(params.longitudsalida)));
        // this.setCoordEnd(42.0069376,2.2331392);
        //id_rt_operario??

    }


    /**
     * Devuelve la concatenación con ', '
     * de los nombres de los productos.
     *
     * @returns {string}
     * @memberof ClockIn
     */
    getProductsList(): string{
        return this.products.map(product=>product.name).join(" | ");
    }


    /**
     * Devuelve el primer producto del array de productos.
     *
     * Si no hay productos devuelve un nuevo producto.
     *
     * @returns {Product}
     * @memberof ClockIn
     */
    getProduct(): Product{
        if(this.products.length == 0) return new Product();
        return this.products[0];

    }

    /**
     *  Devuelve el nombre de la operación.
     *
     * @returns {string}
     * @memberof ClockIn
     */
    getOperationName(): string{
        return this.operation.name;
    }

    /**
     * Devuelve la fecha inicio como Moment.
     *
     * @returns {moment.Moment}
     * @memberof ClockIn
     */
    getStartTime(){
        if(!this.start) return null;
        let date = moment(this.start, "YYYY-MM-DD HH:mm:ss");
        return date;
    }


    /**
     * Devuelve la fecha fin como Moment.
     *
     * @returns {moment.Moment}
     * @memberof ClockIn
     */
    getEndTime(): moment.Moment{
        if(!this.end) return null;
        let date = moment(this.end, "YYYY-MM-DD HH:mm:ss");
        return date;
    }


    /**
     * Devuelve la lista de productos relacionados con la OF.
     *
     * @returns {Array<Product>}
     * @memberof ClockIn
     */
    getRelatedProducts(): Array<Product>{
        return this.relatedProducts;
    }

    /**
     * Establece la lista de productos relacionados.
     *
     * @param {Array<any>} products El array de productos
     * @memberof ClockIn
     */
    setRelatedProducts(products: Array<any>): void{
        this.relatedProducts =  products.map(product=>new Product(product));

    }

    /**
     * Devuelve la operaciones relacionadas con los productos asignados.
     *
     * @returns {Array<Operation>}
     * @memberof ClockIn
     */
    getRelatedOperations(): Array<Operation>{
        return this._relatedOperations;
    }

    /**
     * Establece las operaciones relacionadas con los productos asignados.
     *
     * @param {Array<any>} operations El array de operaciones
     * @memberof ClockIn
     */
    setRelatedOperations(operations: Array<any>): void{
        this.relatedOperations = operations.map(operation=>new Operation(operation));
    }

    /**
     * Calcula la diferencia de tiempo entre el inicio y fin de la fichada.
     *
     * @returns {string} Diferencia entre tiempo de inicio y fin
     * @memberof ClockIn
     */
    calcTotalTime(): string{
        if(!this.start || !this.end) return;
        let start:any = this.getStartTime();
        let end: any = this.getEndTime();
        let diff = end.diff(start);
        return moment(diff).format('HH:mm:ss');
    }


    /**
     * Calcula la diferencia de tiempo entre el inicio y un tiempo especificado.
     *
     * Si se especifica el tiempo, calcula hasta el tiempo fin.
     *
     * @param {string} [sEnd=this.end]
     *  @returns {number} Diferencia entre tiempo de inicio y tiempo especificado.
     * @memberof ClockIn
     */
    calcPartialTime(sEnd: string = this.end): number{
        if(!this.start) return null;
        if(!sEnd) sEnd = moment().format('YYYY-MM-DD HH:mm:ss');
        let start:any = this.getStartTime();
        let end: any = moment(sEnd, "YYYY-MM-DD HH:mm:ss");
        let diff = end.diff(start);
        return diff;
    }

    startClockIn(){
        this.start = Date.now().toString();
    }

    /**
     * True si la fichada tiene tiempo fin.
     *
     * False en caso contrario.
     *
     * @returns {boolean}
     * @memberof ClockIn
     */
    isEnded(): boolean{
        return this.end? true:false;
    }

    /**
     * True si la fichada tiene tiempo de inicio.
     *
     * False en caso contrario.
     *
     * @returns {boolean}
     * @memberof ClockIn
     */
    isStarted(): boolean{
        return this.start? true: false;
    }

    /**
     * True si la fichada tiene tiempo de inicio pero no de fin.
     *
     * False en caso contrario.
     *
     * @returns {boolean}
     * @memberof ClockIn
     */
    isRunning(): boolean{
        if(!this.isEnded() && this.isStarted()) return true;
        return false;
    }

    /**
     * Devuelve una cadena que representa el estado de la fichada:
     * 'ended': tiene tiempo de inicio y fin.
     * 'running: tiene tiempo de inicio pero no de fin.
     * 'pending': no tiene tiempo de inicio ni de fin.
     *
     * @returns {string}
     * @memberof ClockIn
     */
    getState(): string{
        if(this.isEnded()) return 'ended';
        if(this.isRunning()) return 'running';
        return 'pending';
    }

    /**
     *  Devuelve si la fichada tiene asignado el código de operador.
     *
     * @returns {boolean} True si tiene código de operador.
     * @memberof ClockIn
     */
    isAssigned(): boolean{
        return this.operator?true:false;
    }

    /**
     * Crea una copia de la clase.
     *
     * @returns {ClockIn}
     * @memberof ClockIn
     */
    copy(): ClockIn{
        let clockIn = new ClockIn();
        clockIn.operator = this.operator;
        clockIn.name = this.name;
        clockIn.manufacturingOrder = this.manufacturingOrder;
        clockIn.regMO = this.regMO;
        clockIn.products = this.products.map(product=>new Product(product));
        clockIn.operation = new Operation(this.operation);
        clockIn.order = this.order;
        clockIn.client = this.client;
        clockIn.start = this.start;
        clockIn.end = this.end;
        clockIn.relatedProducts = this.relatedProducts.map(product=> new Product(product));
        clockIn.relatedOperations = this.relatedOperations.map(operation=> new Operation(operation));
        clockIn.register = this.register;
        clockIn.observations = this.observations;
        clockIn.qty = this.qty;
        clockIn.qtyFab = this.qtyFab;
        clockIn.time = this.time;
        return clockIn;
    }


    /**
     * Compara dos objectos ClockIn.
     *
     * @param {ClockIn} clockIn El objecto a comparar.
     * @returns {boolean}
     * @memberof ClockIn
     */
    isEqual(clockIn: ClockIn): boolean{

        if(clockIn.operator != this.operator) return false;
        if(clockIn.manufacturingOrder != this.manufacturingOrder) return false;
        if(JSON.stringify(clockIn.operation) != JSON.stringify(this.operation)) return false;
        if(JSON.stringify(clockIn.products.sort()) != JSON.parse(JSON.stringify(this.products.sort()))) return false;
        if(clockIn.order != this.order) return false;
        if(clockIn.client != this.client) return false;
        if(clockIn.start != this.start) return false;
        if(clockIn.end != this.end) return false;
        if(JSON.stringify(clockIn.relatedOperations.sort()) != JSON.stringify(this.relatedOperations.sort())) return false;
        if(JSON.stringify(clockIn.relatedProducts.sort()) != JSON.stringify(this.relatedProducts.sort())) return false;
        return true;
    }

    /**
     * Estandariza los parámetros para la clase.
     *
     * @param {*} param
     * @returns {string}
     * @memberof ClockIn
     */
    formatParam(param: any): string{
        if(typeof param == 'undefined') return '';
        if(typeof param === null) return '';
        if( param === '--') return '';
        return param;
    }



    /**
     * Devuelve True si la fichada no està inicializada.
     *
     * False en caso contrario.
     *
     * @returns {boolean}
     * @memberof ClockIn
     */
    isEmpty(): boolean{
        return this.manufacturingOrder?false:true;
    }


    /**
     * Reseta todas las variables de la clase.
     *
     * @memberof ClockIn
     */
    reset(){
        this._operator = '';
        this._name = '';
        this._start = '';
        this._end= '';
        this._time = ''
        this._qty = 0;
        this._operator= '';
        this._manufacturingOrder= '';
        this._operation = new Operation();
        this._products = [];
        this._order= '';
        this._client= '';
        this._observations= '';
    }


    /**
     * Devuelve un objecto con los parámetros para la modificación/creación de una fichada.
     *
     * @memberof ClockIn
     */
    getRequestParams(){
        let params = {
            cod_operario: this.operator,
            //id_reg_ofs: this.regMO,
            id_reg_ofsproductos: this.getProduct().code,
            id_reg_ofsprod_operacion: this.operation.code,
            hora_ini: moment(this.start,'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmmss'),
            hora_fin:  moment(this.end,'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmmss'),
            cantidad: this.qtyFab,
            observaciones: this.observations
        }
        return params;
    }

    /**
     * Devuelve un objecto con los parámetros para la modificación/creación de una fichada.
     *
     * @memberof ClockIn
     */
    getRequestParams2(){
        let params = {
            cod_operario: this.operator,
            //id_reg_ofs: this.getProduct().of,
            id_reg_ofsproductos: this.getProduct().code,
            id_reg_ofsprod_operacion: this.operation.code,
            hora_ini: moment(this.start,'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmmss'),
            hora_fin:  moment(this.end,'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmmss'),
            cantidad: this.qtyFab,
            observaciones: this.observations
        }
        return params;
    }


    /**
     * Válida que los campos necesarios para editar/fichar sean correctos.
     *
     * @returns {boolean}
     * @memberof ClockIn
     */
    validateUDData(): boolean{
        return true;
    }

   /**
    * Devuelve el código + nombre de una OF
    *
    * @returns {string} El código+nombre de la OF
    * @memberof ClockIn
    */
   getInternalString(): string{
        return this.manufacturingOrder + (this.observations?': ' + this.observations :'');
   }

   /**
    * Devuelve fecha con 2 decimales
    */
   getRoundTime(): string{
        return parseFloat(this.time).toFixed(2);
   }
}



// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/clock-in.model.ts